import { render, staticRenderFns } from "./ItemsPerPage.vue?vue&type=template&id=a53f53bc&scoped=true&"
import script from "./ItemsPerPage.vue?vue&type=script&lang=js&"
export * from "./ItemsPerPage.vue?vue&type=script&lang=js&"
import style0 from "./ItemsPerPage.vue?vue&type=style&index=0&id=a53f53bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a53f53bc",
  null
  
)

export default component.exports